var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"vx-navbar-wrapper navbar-full p-0"},[_c('vs-navbar',{staticClass:"navbar-custom navbar-skelton",class:_vm.navbarClasses,style:(_vm.navbarStyle),attrs:{"color":_vm.navbarColor}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }